import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import { connect } from 'react-redux';
import CatalogueGrid from './CatalogueGrid';
import genericActions, { handleBottomSlider } from '../Generic/actions/genericActions';
import { catalogue_structure } from '../../catalogues';
import { Toolbar } from '@mui/material';

export const BottomSlider = ({ open, catalogue, handleBottomSlider, drawer_props = {} }) => {
	// const footerHeight = document.getElementById('footer-element').offsetHeight;
	const [footerHeight, setfooterHeight] = React.useState(36);

	useEffect(() => {
		const element = document.getElementById('footer-element');

		if (element) {
			setfooterHeight(element.offsetHeight);
		}
	}, []);

	return (
		<Drawer
			anchor={'bottom'}
			open={open}
			onClose={() => handleBottomSlider(false, catalogue)}
			classes={{ paper: 'generic-bottomslider-main' }}
			PaperProps={{
				sx: { width: { xs: '100%' }, minWidth: { xs: '100%' }, maxWidth: { xs: '100%' } },
			}}
			{...drawer_props}
		>
			{drawer_props?.variant === 'permanent' && <Toolbar />}
			<CatalogueGrid catalogue={catalogue} />
			{drawer_props?.variant === 'permanent' && (
				<Toolbar sx={{ height: footerHeight + 'px !important', minHeight: footerHeight + 'px !important' }} />
			)}
		</Drawer>
	);
};

BottomSlider.propTypes = {
	open: PropTypes.bool.isRequired,
	catalogue: PropTypes.shape(catalogue_structure),
	handleBottomSlider: PropTypes.func.isRequired,
	drawer_props: PropTypes.shape({
		anchor: PropTypes.string,
		classes: PropTypes.object,
		PaperProps: PropTypes.object,
		ModalProps: PropTypes.object,
		SlideProps: PropTypes.object,
		variant: PropTypes.string,
		sx: PropTypes.oneOfType([
			PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
			PropTypes.func,
			PropTypes.object,
		]) /** MUI sx prop */,
	}),
};

const mapStateToProps = (state) => ({
	open: state.generic.bottom_slider.open,
	catalogue: state.generic.bottom_slider.catalogue,
	drawer_props: state.generic.bottom_slider.drawer_props,
});

const mapDispatchToProps = { handleBottomSlider: genericActions.handleBottomSlider };

export default connect(mapStateToProps, mapDispatchToProps)(BottomSlider);
